// This was extracted from https://raw.githubusercontent.com/ioBroker/ioBroker.js-controller/master/lib/exitCodes.js
// Keep this in sync when a new exit code is added
export {};
